import React, { useCallback } from 'react'
import { withRouter } from 'react-router'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { toast } from 'react-toastify'

// reactstrap components
import { Button, Container, Row, Col, Form, Input, InputGroupAddon, InputGroupText, InputGroup } from 'reactstrap'
import WhiteFooter from 'components/Footers/WhiteFooter.js'
import logoMural from 'assets/img/logo_mural_2.png'
import { UsersService } from 'services/users'
import ErrorText from 'components/Texts/ErrorText'

const schema = yup.object().shape({
  Senha: yup
    .string()
    .required('Por favor, preencha uma senha')
    .min(6, 'Mínimo permitido é de 6 caracteres')
    .max(15, 'Máximo permitido é de 15 caracteres')
    .nullable(),
})

const RedefinirSenhaPage = ({ history, match }) => {
  const { errors, register, handleSubmit } = useForm({ resolver: yupResolver(schema) })

  const { guid } = match.params

  const goBack = useCallback(() => {
    history.push('/login')
  }, [history])

  const onSubmit = useCallback(
    async (value) => {
      try {
        const response = await UsersService.changePassword(guid, { Senha: value.Senha })
        if (response.status === 200) {
          toast.success('Sucesso! Nova senha salva com sucesso')
          history.push('/login')
        }
      } catch (e) {
        toast.error(e?.response?.data || e.message)
      }
    },
    [guid, history]
  )

  return (
    <>
      <div className="section">
        <Container className="text-center">
          <Row>
            <Col style={{ textAlign: 'end' }}>
              <Button onClick={goBack} className="btn-round" color="#000">
                <span>X</span>
              </Button>
            </Col>
          </Row>
          <Row>
            <Col>
              <img src={logoMural} style={{ width: 260 }} alt="" />
            </Col>
          </Row>
          <Row>
            <Col className="ml-auto mr-auto text-center" md="12">
              <p
                className="description"
                style={{
                  fontWeight: 400,
                  color: '#000',
                  letterSpacing: 2,
                  lineHeight: 1.6,
                  marginTop: 30,
                }}
              >
                <span style={{ fontWeight: 600 }}>Crie sua nova senha.</span>
              </p>
            </Col>
          </Row>
        </Container>

        <Container className="text-center" style={{ marginTop: 30, marginBottom: 30 }}>
          <Form id="consulta-form" className="consulta-form" onSubmit={handleSubmit(onSubmit)}>
            <div className="title-brand" style={{ marginTop: 15 }}>
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText
                    style={{
                      borderRadius: 20,
                      marginRight: 10,
                      height: 45,
                      paddingLeft: 19,
                      paddingRight: 20,
                    }}
                  >
                    <i className="nc-icon nc-lock-circle-open" />
                  </InputGroupText>
                </InputGroupAddon>
                <Input
                  innerRef={register}
                  placeholder="Nova Senha"
                  type="password"
                  id="Senha"
                  name="Senha"
                  style={{
                    borderRadius: 20,
                    height: 45,
                    paddingLeft: 20,
                    letterSpacing: 3,
                  }}
                />
              </InputGroup>
              <ErrorText errors={errors} name="Senha" />
            </div>
            <div className="title-brand" style={{ marginTop: 12, letterSpacing: 4, marginBottom: 0 }}>
              <Button
                errors={Object.keys(errors).length <= 0}
                className="btn-round"
                type="submit"
                style={{
                  paddingTop: 10,
                  paddingBottom: 5,
                  fontSize: 14,
                  letterSpacing: 4,
                  textTransform: 'none',
                  backgroundColor: '#16057C',
                  color: '#FFF',
                  border: 0,
                  width: '100%',
                  height: 45,
                  borderRadius: 20,
                }}
              >
                Alterar
              </Button>
            </div>
          </Form>
        </Container>

        <WhiteFooter />
      </div>
    </>
  )
}

export default withRouter(RedefinirSenhaPage)
